export const FIELD_REGEX = {
  sets: /[^0-9]/g,
  reps: /[^0-9xX,+-]/g,
  rest: /[^0-9]/g,
  intensity: /[^0-9a-zA-Z%]/g,
  tempo: /[^0-9-]/g,
  notes: null, // no filtramos, solo maxLength
  title: null, // solo tamaño
  dayLabel: null, // solo tamaño
};

export const sanitizeInput = (field, value) => {
  const regex = FIELD_REGEX[field];
  return regex ? value.replace(regex, "") : value;
};

export const createInputHandler = (field, setState) => (e) => {
  const clean = sanitizeInput(field, e.target.value);
  setState((prev) => ({ ...prev, [field]: clean }));
};

export const createSimpleHandler = (field, setValue) => (e) => {
  const clean = sanitizeInput(field, e.target.value);
  setValue(clean);
};
